import { loadMathLibAsync, pitchDetector2, sampleAlloc } from "../../services/MathWasm";
import { IPitchAlgo } from "../abstraction/IPitchAlgo";

export class PitchAlgo2Wasm implements IPitchAlgo {

    async initAsync(sampleRate: number, dataSize: number) {

        await loadMathLibAsync();
        this.sampleRate = sampleRate;
        this.buffer = sampleAlloc(dataSize);
    }
   

    getPicth(timeData: Float32Array, freqData: Float32Array) {

        this.buffer.set(timeData);
        return pitchDetector2(this.sampleRate);
    }

    release() {

    }

    
    sampleRate: number;
    buffer: Float32Array;
} 